export enum UNSUPPORTED_CONTENT_LEVEL_SEVERITY {
	NORMAL = 'normal',
	DEGRADED = 'degraded',
	BLOCKING = 'blocking',
}
